"use client";
import { useEffect } from "react";

import { deferredStylesheets } from "@/lib/stylesheets";

const stylesToLoad = [...new Set(deferredStylesheets)];

export default function DeferredStyles() {
  useEffect(() => {
    stylesToLoad.forEach((href) => {
      if (document.querySelector(`link[data-href='${href}']`)) return;

      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      link.media = "print";
      link.setAttribute("data-href", href);
      link.onload = () => {
        link.media = "all";
      };

      document.head.appendChild(link);
    });
  }, []);

  return null;
}
